import { Skeleton } from "@/components/ui/skeleton";

export const PropertiesSkeleton = () => (
  <div className="container mx-auto px-4 md:px-6 py-6 md:py-8">
    {/* Tab bar */}
    <Skeleton className="h-10 w-80 rounded-lg mb-6" />
    {/* Subtitle */}
    <Skeleton className="h-5 w-48 mb-4" />
    {/* Filters bar */}
    <Skeleton className="h-12 w-full mb-6 rounded-lg" />
    {/* Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {[...Array(8)].map((_, i) => (
        <div key={i} className="rounded-lg border overflow-hidden">
          <Skeleton className="h-48 w-full" />
          <div className="p-4 space-y-3">
            <Skeleton className="h-5 w-16 rounded-full" />
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-5 w-32" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
